<template>
<div>
    <div class="vx-row">
        <div class="vx-col w-full">
            <div class="calificacionCaja flex justify-end">
                <span class="nota">Calificación: <i class="fa-solid fa-pen-to-square"></i>
                    <span class="text-3xl p-2"> {{ intentoSelected.calificacion }}</span>
                    <span class="text-2xl p-2"> / {{ intentoSelected.puntaje }}</span>
                </span>
            </div>
        </div>
    </div>
    <div class="padre mt-4">
        <div class="vx-col w-3/5 mx-auto text-center p-6 rounded-full bg1 encabezado">
            Repaso de {{ repasoSelected.libro.nombrelibro }}
        </div>
        <!--evaluacion-->
        <div class="vx-row">
            <!-- <div class="vx-col w-full mt-4">
                <p><b>Escoje</b> la opción correcta y <b>selecciona</b> dentro de las respuestas.</p>
            </div> -->
            <!--paginacion-->
            <div class="vx-col w-full mt-3 p-3">
                <div class="flex justify-center">
                    <!-- <span class="mr-3 title1">Pregunta:</span> -->
                    <div v-for="(item, key) in arrayQuestions" :key="key">
                        <vs-button :class="'tipo' + item.id + '  colorbase boton-pagination mx-2'" @click="mostrarPregunta(key)" :color="color1" type="border">{{ key + 1}}</vs-button>
                    </div>
                </div>
            </div>
        </div>
        <!--preguntas-->
        <div class="vx-row" v-for="(item,key) in tmpQuestions" :key="key">
            <template v-if="item.isQuestionActive == 1">
                <div class="vx-col w-full mt-5 margen-1">
                    <vs-row class="pl-4 pr-4">
                        <vs-col vs-w="10" class="title2">
                            {{key +1 }}. {{ item.pregunta }}
                        </vs-col>
                        <vs-col vs-w="2" class="text-right mt-1">
                            {{ item.puntajeOpcion }} / {{ item.puntaje }} pts.
                        </vs-col>
                    </vs-row>
                    <!-- <p class="title2 ml-3"></p>
                    <p class="ml-4 mt-1">{{ item.puntajeOpcion }} / {{ item.puntaje }} pts.</p> -->
                </div>
                <!--imagen-->
                <div class="vx-col w-full mt-5">
                    <div class="flex justify-start">
                        <img @click="urlImagen=item.url;popupVerImagen = true;" v-if="item.url!='' && item.url!='null' && item.url!=null" :src="$data_book+'archivos/'+'preguntas'+'/'+item.url" class="img-responsive mt-5 cursor-pointer" width="200" height="200" style="border-radius: 5px;">
                    </div>
                </div>
                <!--opciones-respuestas-->
                <!-- <div class="vx-col w-full mt-4 bg3 opcionesTitulo">
                    <p class=""><b>Opciones de respuesta</b></p>
                </div> -->
                <div>
                    <small style="font-size: 10px;" v-if="item.id_tipo == idPreguntaMultiple"> ( Existe más de 1 respuesta correcta. )</small>
                </div>
                <div class="vx-col w-full opciones">
                    <div v-if="item.id_tipo == idPreguntaColumna">
                        <table style="width: 100%;" class="ml-3" v-if="item.respuestas.length > 0">
                            <tr>
                                <th>{{ item.columna1 }}</th>
                                <th>{{ item.columna2 }}</th>
                                <th>Calificación</th>
                                <th></th>
                            </tr>
                            <tr v-for="(tr, indexitem) in item.respuestas[0].respuesta" :key="indexitem">
                                <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                <td>
                                    {{ tr.seleccionar }}
                                </td>
                                <td>
                                    {{ tr.calificacion }}
                                </td>
                                <td>
                                    <span style="font-size:25px;" class="text-success" v-if="tr.calificacion > 0"><i class="fa-regular fa-circle-check"></i></span>
                                    <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                </td>
                            </tr>
                        </table>
                        <!--en el caso que no este el array item.respuestas colocar en cero la califiacion-->
                        <table style="width: 100%;" v-else>
                            <tr>
                                <th>{{ item.columna1 }}</th>
                                <th>{{ item.columna2 }}</th>
                                <th>Calificación</th>
                                <th></th>
                            </tr>
                            <tr v-for="(tr, indexitem) in item.opciones" :key="indexitem">
                                <td><b>{{ indexitem + 1 }}.</b> {{ tr.respuesta }}</td>
                                <td>
                                </td>
                                <td>
                                    0
                                </td>
                                <td>
                                    <span style="font-size:25px;" class="text-danger"><i class="fa-regular fa-circle-xmark"></i></span>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!--pregunta multiple-->
                    <div v-else-if="item.id_tipo == idPreguntaMultiple">
                        <div v-if="item.respuestas.length > 0">
                            <ul class="leftx" v-for="(tr,key2) in item.respuestas[0].respuesta" :key="key2">
                                <li class="my-2">
                                    <div class="flex" style="justify-content: space-between;">
                                        <div>
                                            <vs-checkbox disabled v-model="tr.seleccionar" color="success">{{ tr.respuesta }}</vs-checkbox>
                                        </div>
                                        <div>
                                            <span class="mr-3 font-semibold">{{ tr.calificacion }}</span>
                                            <span style="font-size:25px;" class="text-success" v-if="tr.calificacion > 0"><i class="fa-regular fa-circle-check"></i></span>
                                            <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                        <div v-else>
                            <ul class="leftx" v-for="(tr,key2) in item.opciones" :key="key2">
                                <li class="my-2">
                                    <div class="flex" style="justify-content: space-between;">
                                        <div>
                                            <vs-checkbox disabled v-model="item.seleccionar" color="success">{{ tr.respuesta }}</vs-checkbox>
                                        </div>
                                        <div>
                                            <span style="font-size:25px;" class="text-danger"><i class="fa-regular fa-circle-xmark"></i></span>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!--pregunta simple-->
                    <ul class="leftx" v-else v-for="(tr,key2) in item.opciones" :key="key2">
                        <li class="my-2">
                            <div class="flex" style="justify-content: space-between;">
                                <div>
                                    <vs-checkbox disabled v-model="tr.seleccionado" color="success">{{ tr.respuesta }}</vs-checkbox>
                                </div>
                                <div>
                                    <span style="font-size:25px;" class="text-success" v-if="tr.opcion == 'true'"><i class="fa-regular fa-circle-check"></i></span>
                                    <span style="font-size:25px;" class="text-danger" v-else><i class="fa-regular fa-circle-xmark"></i></span>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </template>
        </div>
    </div>
    <!--modal para ver imagen-->
    <vs-popup class="holamundo" title="" fullscreen :active.sync="popupVerImagen">
        <div v-if="popupVerImagen">
            <div class="flex" style="justify-content: center;">
                <image-zoom :regular="$data_book+'archivos/'+'preguntas'+'/'+urlImagen" :zoom-amount="3" :click-zoom="true" click-message="De click para aumentar" img-class="img-fluid">
                </image-zoom>
            </div>
        </div>
    </vs-popup>
</div>
</template>

<script>
import imageZoom from 'vue-image-zoomer';
export default {
    components: {
        imageZoom
    },
    data() {
        return {
            color1: '#b08181',
            arrayQuestions: [],
            tmpQuestions: [],
            popupVerImagen: false,
            urlImagen: '',
            idPreguntaMultiple: 8,
            idPreguntaAbierta: 7,
            idPreguntaColumna: 5,
        }
    },
    props: {
        arrayPreguntas: {
            type: Array,
            default: () => []
        },
        repasoSelected: {
            type: Object,
            default: () => {}
        },
        evaluacionEstudiante: {
            type: Object,
            default: () => {}
        },
        intentoSelected: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        let me = this
        me.arrayQuestions = me.arrayPreguntas
        //agregar propiedad mostrar por defecto la primera pregunta en 1 y las demas en 0
        me.arrayQuestions.forEach((element, index) => {
            if (index == 0) {
                element.isQuestionActive = 1
            } else {
                element.isQuestionActive = 0
            }
        });
        me.mostrarPregunta(0)
        me.start()
    },
    methods: {
        start() {
            let me = this
            me.datosPreguntaAbierta = ''
            me.puntajeAbierta = 0
            me.arrayQuestions = me.arrayPreguntas
            //de las opciones de las preguntas voy a validar con cada array de respuestas de cada pregunta
            me.arrayQuestions.forEach(item => {
                let respuestas = item.respuestas
                if (respuestas.length > 0) {
                    let id_respuesta = respuestas[0].respuesta
                    item.opciones.forEach(tr => {
                        //si el id_pregunta de la respuesta es igual al id_pregunta de la pregunta coloco true
                        if (tr.id == id_respuesta) {
                            tr.seleccionado = true
                        } else {
                            tr.seleccionado = false
                        }
                    })
                    item.puntajeOpcion = respuestas[0].puntaje
                } else {
                    item.opciones.forEach(tr => {
                        tr.seleccionado = false
                    })
                    item.puntajeOpcion = 0
                }
            })
        },
        mostrarPregunta(index) {
            let me = this
            me.tmpQuestions = []
            me.arrayQuestions.forEach((element, key) => {
                if (index == key) {
                    element.isQuestionActive = 1
                } else {
                    element.isQuestionActive = 0
                }
            });
            me.tmpQuestions = me.arrayQuestions
            console.log("arrayQuestions", me.arrayQuestions)
        },
    }
}
</script>

<style scoped>
.padre {
    /* border: 1px solid #160008; */
    border-radius: 15px;
    padding: 15px;
    /* border-sizing: border-box; */
    /* overflow: hidden; */
    background-color: rgb(240, 239, 239);
}

.bg1 {
    background: #991623;
}

.bg2 {
    background: #e9e9e9;
}

.bg3 {
    background: #e9e9e9;
}

.color1 {
    color: #fae7e7;

}

.encabezado {
    margin-top: -45px;
    padding: 10px;
    color: white;
    font-size: 22px;
    position: relative
    /* border-top: 20px; */
}

.title1 {
    font-size: 20px;
    color: #420404;
    font-weight: bold;
}

.margen-1{
    border-top: 1px solid #fadada;
    padding-top:15px;

}
.title2 {
    font-size: 20px;
    font-weight: 600;
}

.boton-pagination {
    font-weight: bold;
    font-size: 19px;
    color: #000 !important;
}

.boton-pagination {
    background: white !important;
}

.boton-pagination:hover {
    color: #fff !important;
    background: #8e294b !important;
    border-color: none;
}

.opcionesTitulo {
    padding: 20px;
    /* color: #8e2929; */
    font-size: 18px;
    /* border: 1px solid #fae7e7; */
}

.opciones {
    border-top: 1px solid #fadada;
    padding: 30px;
    color: #000;
    font-size: 16px;
}

/**estilos cuando se selecciona pregunta */
.colorbase {
    background: #f2f2f2;
    border: none;
    padding: 10px;
    border-radius: 10px;

}

.colorSeleccionado {
    background: #cc4d27;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}

.colorSeleccionado:hover {
    background: #ca4646;
    color: white;
    border: none;
    padding: 10px;
    border-radius: 10px;
}

/*fin de preguntas seleccionadas*/
/*reloj*/
.reloj {
    font-size: 20px;
    color: #8e2929;
    font-weight: bold;
}

/*fin de reloj*/
/*calificacion*/
.calificacionCaja {
    /* background: #000; */
    color: white;
    padding: 5px 10px;
    border-radius: 10px;
}

.nota {
    background: #362f2f;
    padding: 10px;
    border-radius: 5px;
}
</style>
